import classNames from 'classnames';
import { Translation } from '~/components/I18n';
import styles from './Stepper.module.scss';

export type StepperProps = {
  className?: string;
  activeStep: number;
  length: number;
};

export const Stepper = ({ className, activeStep, length }: StepperProps) => (
  <div className={classNames(styles.root, className)}>
    {Array.from({ length }).map((_, step) => (
      <div key={step} className={classNames(styles.step, { [styles.active]: activeStep === step })}>
        {activeStep === step ? (
          <Translation name={`citizen_unit_step${step + 1}`} />
        ) : (
          `${step + 1}`
        )}
      </div>
    ))}
  </div>
);
